export default __webpack_public_path__ + "static/media/Review.4cc516f2.svg";